<!--  -->
<template>
  <div>
    <div id="pdf">
      <div class="title">溧阳市家庭医生签约服务协议</div>
      <div class="no">编号：</div>
      <div class="content">
        <van-cell-group>
          <van-cell title="甲方（签约居民）"></van-cell>
          <van-cell title="姓名：" :value="info.FAVOREENAME"></van-cell>
          <van-cell
            title="身份证（居住证）号："
            :value="info.CARDNO"
          ></van-cell>
          <!-- <van-cell
            title="监护人（与签约居民的关系）："
            value=""
          ></van-cell> -->
          <van-cell
            title="监护人身份证号："
            :value="info.GUARDIANCARD"
          ></van-cell>
          <van-cell
            title="本人联系电话："
            :value="info.FAVOREEPHONE"
          ></van-cell>
          <van-cell
            title="监护人联系电话："
            :value="info.GUARDIANPHONE"
          ></van-cell>
          <van-cell title="紧急联系人：" :value="info.CONTACT"></van-cell>
          <van-cell
            title="紧急联系人电话："
            :value="info.CONTACTPHONE"
          ></van-cell>
          <van-cell
            title="医保类别："
            :value="info.RESIDENTNATURE == 1 ? '医保' : '自费'"
          ></van-cell>
          <van-cell title="详细家庭住址：" :value="info.ADDRESS"></van-cell>
          <van-cell title="重点人群："> </van-cell>
          <van-cell>
            <van-checkbox-group v-model="importPersonType">
              <div class="checkbox">
                <van-checkbox
                  style="margin-right: 10px; margin-top: 5px"
                  v-for="v in importPersonList"
                  :name="v.key"
                  disabled
                  :key="v.key"
                >
                  {{ v.value }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell>
          <van-cell title="特殊人群："></van-cell>
          <van-cell>
            <van-checkbox-group v-model="specialPersonType">
              <div class="checkbox">
                <van-checkbox
                  disabled
                  style="margin-right: 10px; margin-top: 5px"
                  v-for="v in personTypeList"
                  :name="v.key"
                  :key="v.key"
                >
                  {{ v.value }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell>
          <van-cell
            title="是否是上年续约："
            :value="info.RENEWAL == 1 ? '是' : '否'"
          ></van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="乙方（签约医生）:" :value="info.signdoc"></van-cell>
          <van-cell
            title="卫生院临床医生："
            :value="info.VILLAGEDOCTOR"
          ></van-cell>
          <van-cell title="联系电话" :value="info.CLINICIAN"></van-cell>
          <van-cell
            title="卫生院乡村医生："
            :value="info.VILLAGEDOCTOR"
          ></van-cell>
          <van-cell title="联系电话" value=""></van-cell>
          <van-cell title="团队其他成员及联系电话" value=""></van-cell>
        </van-cell-group>
        <div class="remark">
          备注：如签约对象为未成年人由其监护人签字；签约对象为精神障碍患者时由其本人/监护人签字；签约对象因年岁已高或其他身体因素无法书写签名时，可由其具有完全民事行为能力的成年子女代签。在非本人签署的情况下，均需备注好与签约对象的身份关系。
        </div>
        <div class="remark">
          为进一步满足居民不断增长的健康需求，充分发挥“健康守门人”的作用，努力使辖区居民享有优质、高效、便捷的基本医疗卫生服务，甲方自愿选择乙方为本人家庭签约服务医生，成为乙方的服务对象。甲、乙双方在充分了解服务条款的前提下，签订本协议。
        </div>
        <van-cell-group>
          <van-cell title="一、选择签约服务包"></van-cell>
          <van-cell title="基本医疗服务包（必选）：">是</van-cell>
          <van-cell>
            <van-checkbox-group v-model="basicPack">
              <div class="checkbox">
                <van-checkbox
                  disabled
                  style="margin-right: 10px; margin-top: 5px"
                  v-for="v in basicPackList"
                  :name="v.key"
                  :key="v.key"
                >
                  {{ v.value }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell>
          <van-cell title="2.个性化服务包（基本服务包+健康管理包）"></van-cell>
          <van-cell>
            <van-checkbox-group v-model="specialPack">
              <div class="checkbox">
                <van-checkbox
                  disabled
                  style="margin-right: 10px; margin-top: 5px"
                  v-for="v in specialPackList"
                  :name="v.key"
                  :key="v.key"
                >
                  {{ v.value }}
                </van-checkbox>
              </div>
            </van-checkbox-group>
          </van-cell>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="二、服务时限"></van-cell>
          <van-cell>
            签约服务时限为{{ getFormatDate(info.BEGINDATE) }}至{{
              getFormatDate(info.ENDDATE)
            }}，协议到期签约对象可以续约、终止或另选家庭医生。</van-cell
          >
        </van-cell-group>
        <van-cell-group>
          <van-cell title="三、双方权利与义务"></van-cell>
          <van-cell title="（一）甲方"> </van-cell>
          <van-cell
            >权利：自愿选择签约家庭医生；签约后在规定时限内享有约定的服务项目；监督签约服务项目规范实施。</van-cell
          >
          <van-cell
            >义务：理解家庭医生工作的特殊性，支持配合家庭医生开展工作；首诊在村卫生室或乡镇卫生院；优先选择基本药物，接受家庭医生的转诊建议；主动缴纳契约费用，参与签约服务工作测评。</van-cell
          >
          <van-cell title="（二）乙方"> </van-cell>
          <van-cell
            >权利：得到签约群众的尊重和客观评价；根据签约服务政策享有应得的劳动所得。</van-cell
          >
          <van-cell
            >义务：按约定认真履行服务承诺；严格执行诊疗规范，提供优质安全的医疗卫生服务；加强学习，提升服务能力；执行城乡居民基本医保政策，控制医药费用；接受群众的监督与评价，不断提高服务质量和群众满意度。</van-cell
          >
        </van-cell-group>
        <van-cell-group>
          <van-cell title="四、服务费用和结算"></van-cell>
          <van-cell>
            （一）无偿协议签约有效期满后，如甲方不提出变更或解约要求，视为自动续约，有偿协议一年一签。
          </van-cell>
          <van-cell
            >（二）签约服务费用参考常州市收费标准后打包定价，甲方自愿选择，由乙方出具收款凭证。</van-cell
          >
          <van-cell
            >（三）甲方对服务不满意或其他原因，要求提前终止服务的，经调查核实后应在扣除实际服务的费用后，双方进行协商，退还甲方。</van-cell
          >
          <van-cell
            >（四）甲方可根据自身健康需求选择多种服务包内套餐，对同时签约两个及以上个性化服务包内套餐的居民，其中一个签约套餐的签约服务费由医保基金、基本公共卫生服务经费和签约居民三方按比例共同分担，签约的其他套餐服务费用全部由其个人承担。</van-cell
          >
        </van-cell-group>
        <van-cell-group>
          <van-cell title="五、其他约定"></van-cell>
          <van-cell>
            （一）甲方如对乙方服务不满意，可向上级单位投诉；经协调不能解决问题，可申请更换签约家庭医生。
          </van-cell>
          <van-cell
            >（二）如甲方对乙方隐瞒病史信息，或不执行乙方服务方案，而由此影响服务及产生的后果由甲方承担。</van-cell
          >
          <van-cell
            >（三）本协议一式二份，甲乙双方各执一份，具有同等法律效力。</van-cell
          >
          <van-cell>（四）本协议解释权归乙方所有。</van-cell>
        </van-cell-group>
        <van-cell-group>
          <template v-if="$route.query.type == 1 || signList.residentsignature">
            <van-cell title="甲方签字"></van-cell>
            <img
              :src="signList.residentsignature"
              v-if="signList.residentsignature"
              alt=""
            />
            <sign-canvas
              v-else
              class="sign-canvas"
              ref="SignCanvas1"
              :options="options"
              v-model="sign1"
            />
          </template>
          <template v-if="$route.query.type == 2 || signList.ruralsignature">
            <van-cell title="乙方卫生院医生签字："></van-cell>
            <img
              :src="signList.ruralsignature"
              v-if="signList.ruralsignature"
              alt=""
            />
            <sign-canvas
              v-else
              class="sign-canvas"
              ref="SignCanvas2"
              :options="options"
              v-model="sign2"
            />
          </template>

          <template
            v-if="$route.query.type == 3 || signList.healthcentersignature"
          >
            <van-cell title="乙方乡村医生签字："></van-cell>
            <img
              :src="signList.healthcentersignature"
              v-if="signList.healthcentersignature"
              alt=""
            />
            <sign-canvas
              v-else
              class="sign-canvas"
              ref="SignCanvas3"
              :options="options"
              v-model="sign3"
            />
          </template>
          <div
            class="btns"
            v-if="showBtns"
            style="text-align: center; padding: 10px 0"
          >
            <van-button type="primary" size="small" @click="submit"
              >提交签名</van-button
            >
            <van-button
              type="danger"
              style="margin-left: 20px"
              size="small"
              @click="reset"
              >清空</van-button
            >
          </div>
        </van-cell-group>
        <div class="title">溧阳市家庭医生签约服务包内容及收费标准</div>
        <img
          class="protocol-img"
          @click="showImage"
          :src="protocolImg"
          alt=""
        />
        <div class="mark">
          注：1.
          基本服务包免费提供；个性化服务包由基本公共卫生服务经费、医保和个人各支付50元（未参加溧阳市基本医疗保险的居民，医保基金承担的经费由居民个人支付）；对同时签约两个及以上个性化服务包内套餐的居民，其中一个签约套餐的签约服务费由医保基金、基本公共卫生服务经费和签约居民三方按比例共同分担，签约的其他套餐服务费用全部由其个人承担。
        </div>
        <div class="mark">3.为白血病患儿免费提供签约服务。</div>
        <div class="mark">4.基本公共卫生服务项目按国家规范执行。</div>
        <div class="mark">5.协议解释权归乙方。</div>
        <div class="mark">
          2.对城乡居民中的“三无”、“五保”、“低保”、“重点优抚”、“计划生育特殊家庭”、“无固定收入重度残疾人”和“农村建档立卡贫困人口”等特殊人群（以市农工办、民政局、卫健局、退役军人事务局等部门提供名单为准，如在名单外需提供相关证明，家庭医生留存证明复印件）签约服务中居民个人付费部分由市财政承担。
        </div>
      </div>
    </div>
    <van-button
      @click="getPdf"
      type="primary"
      round
      style="margin: 20px auto; display: block; width: 60%"
      >打印pdf</van-button
    >
  </div>
</template>

<script>
import protocolImg from '@/assets/images/protocol.png'
import { ImagePreview } from 'vant'
import { commonAjax1, commonAjax2 } from '@/common/js/api'
import domtoimage from 'dom-to-image'
import { jsPDF } from 'jspdf'
import html2pdf from 'html2pdf.js'
import moment from 'moment'
export default {
  async mounted() {
    this.getInfo()
    this.getSign()
    this.personTypeList = await this.getDic(1)
    this.importPersonList = await this.getDic(2)
    this.basicPackList = await this.getDic(3)
    this.specialPackList = await this.getDic(4)
  },

  data() {
    return {
      info: {},
      importPersonType: [],
      specialPersonType: [],

      pdfUrl: '',
      activeNames1: [],
      activeNames2: [],
      showButton: true,
      showSign: true,
      activeNames3: [],
      importPersonList: [],
      basicPackList: [],
      specialPackList: [],
      signPackList: [],
      showBtns: true,
      chargeInfo1: [
        {
          title: '孕产妇',
          content: `1.为其建立居民健康档案并定期维护更新2.孕13周前建立《母子健康手册》，并进行第1次产前检查3.孕中期提供2次健康管理服务4.孕晚期提供2次健康管理服务5.产妇出院后1周内到产妇家中进行产后访视服务,6.产后 42 天为产妇提供1次健康检查服务7.为其提供健康教育和指导`,
        },
        {
          title: '0-6岁儿童',
          content:
            '1.为其建立居民健康档案并定期维护更新2.为新生儿提供一次家庭访视服务3.为满月新生儿提供一次健康管理服务4.为婴幼儿提供8次健康管理服务，包括3次血常规（或血红蛋白）检测和4次听力筛查5.为学龄前儿童提供健康管理服务，包括血常规（或血红蛋白）检测和视力筛查等6.为适龄儿童按规定全程接种一类疫苗7.为 0-36 个月常住儿童提供6次中医药健康管理服务，对儿童家长进行儿童中医药健康指导8.进行科学喂养（合理膳食）、生长发育、疾病预防、伤害预防、口腔保健等健康指导',
        },
        {
          title: '65岁以上老年人',
          content:
            '1.为其建立居民健康档案并定期维护更新2.每年为65岁以上老年人提供1次健康体检服务，1次中医药健康管理服务3.开展个性化健康教育，进行健康指导',
        },
        {
          title: '原发性高血压病患者',
          content:
            '1.为其建立居民健康档案并定期维护更新2.对辖区内35岁及以上常住居民，每年为其免费测量一次血压（非同日三次测量）3.每年提供至少4次面对面的随访4.提供分类干预指导，进行个性化健康教育5.每年进行1次较全面的健康检查',
        },
        {
          title: '2型糖尿病患者',
          content:
            '1.为其建立居民健康档案并定期维护更新2.每年提供4次免费空腹血糖检测，至少进行4次面对面随访3.提供分类干预指导，开展针对性的健康教育4.每年进行1次较全面的健康体检',
        },
        {
          title: '严重精神障碍患者',
          content:
            '1.为患者进行一次全面评估，为其建立居民健康档案2.协助对应管理的严重精神障碍患者每年至少随访4次3.提供分类干预指导，进行个性化健康教育4.在患者病情许可的情况下，征得监护人与(或)患者本人同意后，每年进行1次健康检查',
        },
        {
          title: '肺结核患者',
          content:
            '1.为其建立居民健康档案并定期维护更新2.接到上级专业机构管理肺结核患者的通知单后，在72小时内访视患者3.督促肺结核患者按时按要求服药，至少每月提供1次随访评估4.为其提供健康教育和指导',
        },
        {
          title: '普通人群',
          content:
            '1.为其建立居民健康档案并定期维护更新2.每年为签约居民进行一次健康生活方式和健康状况评估，开展可干预危险因素、重点慢性非传染性疾病和重点传染性疾病的健康教育以及有针对性的个体化健康指导',
        },
      ],
      chargeInfo2: [
        {
          title: '辖区常住居民',
          content:
            '1.常见病、多发病的诊断和治疗，疾病康复指导2.为病情需要的签约对象提供转诊预约服务',
        },
      ],
      options: {
        isDpr: false, //是否使用dpr兼容高倍屏 [Boolean] 可选
        lastWriteSpeed: 1, //书写速度 [Number] 可选
        lastWriteWidth: 1, //下笔的宽度 [Number] 可选
        lineCap: 'round', //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: 'bevel', //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: 350, //canvas宽高 [Number] 可选
        canvasHeight: 200, //高度  [Number] 可选
        isShowBorder: true, //是否显示边框 [可选]
        bgColor: '#ddd', //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: '#fff', //网格颜色  [String] 可选
        // writeWidth: 5, //基础轨迹宽度  [Number] 可选
        // maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        // minWriteWidth: 10, // 写字模式最小线宽  [Number] 可选
        writeColor: '#101010', // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType: 'jpg', //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
      sign1: '',
      sign2: '',
      sign3: '',
      protocolImg,
      personTypeList: [],
      basicPack: [],
      specialPack: [],
      signList: {},
    }
  },

  methods: {
    getFormatDate(v) {
      return moment(v).format('YYYY年MM月DD日')
    },
    reset() {
      this.$refs['SignCanvas' + this.$route.query.type].canvasClear()
    },
    getSign() {
      commonAjax2(
        'pcn.myResidentDoctorService',
        'getpic',
        [
          {
            scid: this.$route.query.scid,
          },
        ],
        this.$route.query.token
      ).then((res) => {
        if (res.code == 200) {
          this.signList = res.body
          if (res.body.residentsignature && this.$route.query.type == 1) {
            this.showBtns = false
          }
          if (res.body.healthcentersignature && this.$route.query.type == 3) {
            this.showBtns = false
          }
          if (res.body.ruralsignature && this.$route.query.type == 2) {
            this.showBtns = false
          }
        }
        this.$forceUpdate()
      })
    },
    submit() {
      let params = {
        img: this['sign' + this.$route.query.type],
        type: this.$route.query.type,
        scid: this.$route.query.scid,
      }
      commonAjax2(
        'pcn.myResidentDoctorService',
        'updateSignPic',
        [params],
        this.$route.query.token
      )
        .then((res) => {
          if (res.code === 200) {
            this.$toast.success('提交成功')
            this.getSign()
          }
        })
        .catch((e) => {
          this.$toast.success('提交失败')
        })
    },
    getDic(type) {
      return commonAjax2(
        'pcn.myResidentDoctorService',
        'GetdicBytype',
        [type],
        this.$route.query.token
      ).then((res) => {
        if (res.code == 200) {
          return res.body.map((item) => {
            let key = Object.keys(item)[0]
            let value = item[key]
            return {
              key,
              value,
            }
          })
        }
      })
    },
    getPdf() {
      this.showButton = false
      this.showSign = false
      html2pdf(document.getElementById('pdf')).set({
        pagebreak: { mode: 'avoid-all', before: '#page2el' },
      })
      return
      // this.$nextTick(() => {
      //   window.print()
      // })
    },
    showImage() {
      ImagePreview({ images: [protocolImg] })
    },
    getInfo() {
      commonAjax2(
        'pcn.myResidentDoctorService',
        'getsigninfoByScid',
        [
          {
            scid: this.$route.query.scid,
          },
        ],
        this.$route.query.token
      ).then((res) => {
        if (res.code == 200) {
          this.info = res.body[0]
          this.importPersonType = this.info.zdrq.split(',')
          this.specialPersonType = this.info.tsrq.split(',')
          this.basicPack = this.info.jcfwb.split(',')
          this.specialPack = this.info.tsrqfwb.split(',')
        }
      })
    },
  },

  components: {},

  computed: {},
}
</script>
<style lang='less' scoped>
/deep/ .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
  color: #1989fa;
}
/deep/ .van-checkbox__label--disabled {
  color: #000;
}
/deep/ .van-checkbox__icon--disabled .van-icon {
  background: #fff;
}
.title {
  margin-top: 10px;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
}
.no {
  text-align: right;
  margin-top: 10px;
  padding-right: 50px;
}
.remark {
  padding: 10px 16px;
  text-indent: 2em;
  font-size: 14px;
}
.mark {
  padding: 0 16px;
  font-size: 16px;
}
.protocol-img {
  display: block;
  width: 90%;
  height: auto;
  margin: 10px auto;
}
.sign-canvas {
  display: block;
  margin: 0 auto;
}
.pdfImg {
  // position: fixed;
  // top: 0;
  // left: 0;
  // width: 100vw;
  // height: 100vh;
  // overflow: auto;
  // z-index: 999;
  // background: #fff;
  // img {
  //   width: 100%;
  // }
}
.checkbox {
  display: flex;
  flex-wrap: wrap;
}
</style>
<style lang="less">
#app {
  height: auto;
}
</style>